import React, { useEffect } from "react";
import { store } from "react-notifications-component";
import "./addToBasket.scss";
import { clearAddToBasketMessage } from "../../app/store/alerts/alertsActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FINALIZE_PAGE } from "../../app/routes";
import { State } from "../../app/store";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import EAModal from "../../app/components/shared/Modal/EAModal";
interface IProps {
  info: string | null;
  onHide: Function;
}

const AddToBasketAlerts: React.FC<IProps> = ({ info, onHide }: IProps) => {
  const showPopupAfterAddTicket = useSelector((state: State) => state.config.configuration.popupAfterAddTicket);
  const location = useLocation();

  const showAlert = () => {
    // Nie wyświetlaj komunikatu "Dodano do koszyka" w koszyku
    const isInBasket = location.pathname.includes("/finalize");

    if (isInBasket) {
      return false;
    }

    if (showPopupAfterAddTicket) {
      return true;
    } else {
      return false;
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Wyczyść komunikat automatycznie gdy jesteśmy w koszyku
  useEffect(() => {
    const isInBasket = location.pathname.includes("/finalize");
    if (isInBasket && info) {
      dispatch(clearAddToBasketMessage());
    }
  }, [info, location.pathname, dispatch]);

  useEffect(() => {
    const infoNotifications = () => {
      store.addNotification({
        title: t("informacja"),
        message: Boolean(info) ? info : "",
        type: "info",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
          showIcon: true,
        },
        onRemoval: () => {
          onHide();
        },
      });
    };

    if (info && showAlert()) {
      infoNotifications();
    }
    //eslint-disable-next-line
  }, [info]);

  const closeModal = () => {
    dispatch(clearAddToBasketMessage());
  };

  const handleGoToBasket = () => {
    navigate(FINALIZE_PAGE);
    closeModal();
  };

  if (!info || !showAlert()) {
    return null;
  }

  return (
    <EAModal
      title={t("dodano_do_koszyka")}
      isOpen={Boolean(info && showAlert())}
      onClose={closeModal}
      cancelButtonLabel={t("kontynuuj_zakupy")}
      acceptButtonLabel={t("przejdz_do_koszyka")}
      onAccept={handleGoToBasket}
    >
      <></>
    </EAModal>
  );
};

export default AddToBasketAlerts;
